import React, { useEffect, useState } from "react";
import {
  transformResultsToCompProfileData,
  formatBoldText,
} from "../../../../../services/commonService";
import InsightTable from "../../InsightTable";
import { useParams } from "react-router-dom";
import ParsedTextWithLinks from "../../../../HtmlElements/ParsedTextWithLinks";

function PatentsAndIpActivity({ patentsIpActivity, compView }) {
  const { clientName, competitorName } = useParams();
  const [tabData, setTabData] = useState([]);
  const [tableBelowDescription, setTableBelowDescription] = useState("");

  const [columns, setColumns] = useState([]);
  const [sidebarColumns, setSidebarColumns] = useState([]);
  const [hiddenColumns, setHiddenColumns] = useState([]);

  let allMetrics = [];
  useEffect(() => {
    if (compView === "quantitative") {
      allMetrics = [
        // { key: "patent_title", label: "Patent Title" },
        { key: "filing_year", label: "Filing Year" },
      ];

      setColumns(allMetrics);
      setHiddenColumns([]);
      setSidebarColumns([]);
    } else {
      allMetrics = [
        // { key: "patent_title", label: "Patent Title" },
        { key: "tech_domain", label: "Tech Domain" },
        { key: "filing_year", label: "Filing Year" },
        { key: "region", label: "Region" },
        { key: "source", label: "Source" },
      ];

      setColumns(allMetrics);
      setHiddenColumns([]);
      setSidebarColumns([]);
    }
  }, [compView]);

  // const dummyData = [
  //   {
  //     patent_title: {
  //       value: "Antimicrobial Dressing with Hydrogel Layer",
  //     },
  //     tech_domain: {
  //       value: "Wound Care",
  //     },
  //     filing_year: {
  //       value: "2023",
  //     },
  //     region: {
  //       value: "US",
  //     },
  //   },
  // ];

  useEffect(() => {
    // setTabData(dummyData);
    const transformed = transformResultsToCompProfileData(patentsIpActivity);
    setTabData(transformed);

    setTableBelowDescription(
      // formatBoldText(patentsIpActivity?.[0]?.response?.["tableComments"])
      <ParsedTextWithLinks
        text={patentsIpActivity?.[0]?.response?.["tableComments"] || ""}
      />
    );
  }, [patentsIpActivity]);

  const actions = [
    // { type: "chart", title: "Chart", onClick: () => {} },
    // { type: "conversation", title: "Conversation", onClick: () => {} },
    // { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  const filtersConfig = [
    {
      key: "region",
      label: "Region",
      type: "dropdown",
      options: ["All", "US", "Global", "Europe", "Asia"],
      defaultValue: "All",
    },
    {
      key: "tech_domain",
      label: "Tech Domain",
      type: "dropdown",
      options: [
        "All",
        "Wound Care",
        "Surgical Logistics",
        "Dermatology",
        "Foot Care",
      ],
      defaultValue: "All",
    },
    {
      key: "filing_year",
      label: "Filing Year",
      type: "dropdown",
      options: ["All", "2023", "2024", "2025"],
      defaultValue: "All",
    },
  ];

  return (
    <div className="patent_activity_wrapper">
      <InsightTable
        title="Patents & IP Activity"
        subtitle={`Recent ${
          competitorName ?? "Tailored Chemical Products"
        } patent filings in innovation-focused domains across R&D and IP geographies.`}
        // belowTableDescription={tableBelowDescription}
        belowTableDescription={""}
        defaultSortColumns={["filing_year"]}
        data={tabData}
        metrics={columns}
        rowIdentifier="title"
        actions={actions}
        // filtersConfig={filtersConfig}
      />
    </div>
  );
}

export default PatentsAndIpActivity;
